import LocalStorageConst from '../../constant/localstorage.constant';

export const getKeyValueFromLocalStorage = (key) => {
  if (key) {
    return localStorage.getItem(LocalStorageConst.prefix + key);
  }
  return null;
};
